/* eslint-disable prettier/prettier */
import localize from '../localize';
import vardagaRefinements from './vardaga-website';
import altidenRefinements from './altiden-website';
import stendiRefinements from './stendi-website';

const defaultRefinements = {
  'taxonomies.kommun': localize('refinementKommun')
    ? localize('refinementKommun')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Tjänst': localize('refinementTjanst')
    ? localize('refinementTjanst')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Län': localize('refinementLan')
    ? localize('refinementLan')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Målgrupp': localize('refinementMalgrupp')
    ? localize('refinementMalgrupp')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Segment': localize('refinementSegment')
    ? localize('refinementSegment')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Personkrets inom LSS': localize('refinementPersonkrets')
    ? localize('refinementPersonkrets')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Lagrum': localize('refinementLagrum')
    ? localize('refinementLagrum')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Diagnos/specialiteter': localize('refinementDiagnos')
    ? localize('refinementDiagnos')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'metadata.ssws_driftsform': localize('refinementDriftsform')
    ? localize('refinementDriftsform')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'metadata.ssws_is-new': localize('refinementIsNew')
    ? localize('refinementIsNew')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};

var exportedRefinements = defaultRefinements;

const theme = localize('svb_active_theme') || '';

if (theme === 'vardaga-website') {
  exportedRefinements = vardagaRefinements;
}

if (theme === 'altiden-website') {
  exportedRefinements = altidenRefinements;
}

if (theme === 'stendi-website') {
  exportedRefinements = stendiRefinements;
}

export default exportedRefinements;
